import React, { useEffect } from "react";
import { Box, Grid, TableCell, TableRow, Typography } from "@mui/material";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import { useState } from "react";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ManageSale from "./ManageSale";
import {
  getAllSaleAction,
  setAddSaleResponse,
  updateSaleResponse,
} from "../../../../store/reducers/saleSlice";
import FormField from "../../../../components/common/FormField";
import { SALE_DETAILS_FIELDS } from "./saleAllFields";

const SalesList = () => {
  const tableHeadings1: TableHeading[] = [
    { label: "Type", align: "left" },
    { label: "Description", align: "left" },
    { label: "Percent or Value", align: "left" },
  ];

  const tableHeadings2: TableHeading[] = [
    { label: "Type", align: "left" },
    { label: "Description", align: "left" },
  ];
   const tableHeadings3: TableHeading[] = [
    { label: "Name", align: "left" },
    { label: "Description", align: "left" },
  ];
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [title, setTitle] = useState("");

  const { sales, isAddSaleSuccess, newSaleLocal } = useSelector(
    (state: any) => state.sale
  );

  useEffect(() => {
    dispatch(getAllSaleAction());
  }, [dispatch]);

  useEffect(() => {
    if (isAddSaleSuccess) {
      setOpen(false);
      setDeleteModelShow(false);
      setSelectedRow(null);
      setTitle("");
      dispatch(getAllSaleAction());
      dispatch(setAddSaleResponse(false));
      dispatch(updateSaleResponse(false));
    }
  }, [isAddSaleSuccess, dispatch]);

  const handleOpen = () => {
    setOpen(true);
    setTitle("Add Sale");
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteModelShow(false);
    setSelectedRow(null);
    setTitle("");
    dispatch(setNotificationAction({ message: [], severity: "info" }));
    setAnchorEl(null);
  };

  return (
    <>
      {/* {deleteModelShow && (
        <DeleteAlert
          selectUser={selectedRow}
          alertModalShow={deleteModelShow}
          setAlertModelShow={setDeleteModelShow}
          onHide={handleClose}
        />
      )} */}
      {open && (
        <ManageSale
          open={open}
          onHide={handleClose}
          selectUser={selectedRow}
          title={title}
          isSmallScreen={false} // Assuming this is not used in this component
        />
      )}
      <PageTitle
        title="Sales Details"
        button={"Update Sales"}
        onClick={handleOpen}
      />
      <Grid
        container
        spacing={2}
        sx={{
          padding: "10px",
          mt: 1,
          background: "#E5F4F1",
          borderRadius: "5px",
          border: "1px solid #CFCFCF",
          overflowY: "auto",
        }}
      >
        <Grid
          item
          md={12}
          xs={12}
          sx={{ paddingLeft: "0px !important", paddingRight: "16px" }}
        >
          <Grid container spacing={2}>
            {SALE_DETAILS_FIELDS &&
              SALE_DETAILS_FIELDS.map((field) => (
                <FormField
                  key={field.id}
                  // onPaste={(e) => e.preventDefault()}
                  onKeyDown={(event: any) => {
                    if (
                      event.keyCode === 8 ||
                      event.keyCode === 9 ||
                      event.keyCode === 37 ||
                      event.keyCode === 38 ||
                      event.keyCode === 39 ||
                      event.keyCode === 40 ||
                      event.keyCode === 18 ||
                      event.keyCode === 17 ||
                      event.ctrlKey
                    )
                      return event;
                    if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(event.key)
                    ) {
                      event.preventDefault();
                    } else if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(
                        event.target.value + event.key
                      )
                    ) {
                      event.preventDefault();
                    }
                  }}
                  {...{
                    ...field,
                    value:
                      field.id === "is_minimum_profit_required"
                        ? Boolean(sales[field.id])
                          ? "Yes"
                          : "No"
                        : sales[field.id] ?? "",
                    // value: formData[field.id] || "",
                    variant: "outlined",
                    minRows: 2,
                    isNonMarginTop: true,
                    inSingleGridForm: true,
                    onChange: (event: any) => {},
                    maxLength: 250,
                    InputProps: {
                      ...(field?.inputProps && field?.inputProps),
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? { height: "36px" }
                          : {
                              padding: "6px 12px",
                              // height: "36px",
                            },
                    },
                  }}
                />
              ))}
          </Grid>
        </Grid>

        <>
          <Grid item xs={12} md={12} sx={{ mt: 2 }}>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontWeight: 600,
                color: "#02906F",
                mb: 1,
                fontSize: "1rem",
              }}
            >
              Insurance-Extended Liability Types
            </Typography>
            <TableDesign
              tableHeadings={tableHeadings1}
              tableHeadColor={"#02906f"}
              cellColor={"#fff"}
              pagination={
                sales?.insurance_extended_liability_types?.length > 0
                  ? null
                  : null
              }
              isLoader={false}
              stickyHeader={true}
              filterOption={""}
              setFilterOption={() => {}}
              // extraCSS={{
              //   height: "calc(100%)",
              // }}
            >
              {sales?.insurance_extended_liability_types?.length > 0 ? (
                sales?.insurance_extended_liability_types?.map(
                  (val: any, idx: number) => (
                    <TableRow
                      key={val?.id}
                      sx={{
                        cursor: "pointer",
                        marginTop: "10px",
                        padding: "4px !important",
                        borderRadius: "20px !important",
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                          outline: "2px solid #f0f0f0",
                          borderRadius: "0px !important",
                          outlineOffset: "-2px !important",
                        },
                      }}
                    >
                      <TableCell>{val?.name}</TableCell>
                      <TableCell>{val?.description}</TableCell>
                      <TableCell>
                        {" "}
                        {val?.type === "percent"
                          ? val?.percent != null
                            ? `${val.percent} %`
                            : ""
                          : val?.value != null
                          ? `£ ${val.value}`
                          : ""}
                        
                      </TableCell>
                    </TableRow>
                  )
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Box
                      sx={{
                        height: "10vh",
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          // position: "absolute",
                          fontSize: "1rem",
                          color: "#4A4A4A",
                          textAlign: "center",
                          justifyContent: "center",
                          top: "10px",
                        }}
                      >
                        {"No Data Found."}
                      </span>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableDesign>
          </Grid>
          {/* invoice type */}
          <Grid item xs={12} md={12} sx={{ mt: 2 }}>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontWeight: 600,
                color: "#02906F",
                mb: 1,
                fontSize: "1rem",
              }}
            >
              Lead Types
            </Typography>
            <TableDesign
              tableHeadings={tableHeadings2}
              tableHeadColor={"#02906f"}
              cellColor={"#fff"}
              pagination={sales?.lead_types?.length > 0 ? null : null}
              isLoader={false}
              stickyHeader={true}
              filterOption={""}
              setFilterOption={() => {}}
              // extraCSS={{
              //   height: "calc(100%)",
              // }}
            >
              {sales?.lead_types?.length > 0 ? (
                sales?.lead_types?.map((val: any, idx: number) => (
                  <TableRow
                    key={val?.id}
                    sx={{
                      cursor: "pointer",
                      marginTop: "10px",
                      padding: "4px !important",
                      borderRadius: "20px !important",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                        outline: "2px solid #f0f0f0",
                        borderRadius: "0px !important",
                        outlineOffset: "-2px !important",
                      },
                    }}
                  >
                    <TableCell>{val?.name}</TableCell>
                    <TableCell>{val?.description}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>
                    <Box
                      sx={{
                        height: "10vh",
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          fontSize: "1rem",
                          color: "#4A4A4A",
                          top: "10px",
                        }}
                      >
                        {"No Data Found."}
                      </span>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableDesign>
          </Grid>

           {/* [property] type */}
          <Grid item xs={12} md={12} sx={{ mt: 2 }}>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontWeight: 600,
                color: "#02906F",
                mb: 1,
                fontSize: "1rem",
              }}
            >
              Property Types
            </Typography>
            <TableDesign
              tableHeadings={tableHeadings3}
              tableHeadColor={"#02906f"}
              cellColor={"#fff"}
              pagination={sales?.property_types?.length > 0 ? null : null}
              isLoader={false}
              stickyHeader={true}
              filterOption={""}
              setFilterOption={() => {}}
              // extraCSS={{
              //   height: "calc(100%)",
              // }}
            >
              {sales?.property_types?.length > 0 ? (
                sales?.property_types?.map((val: any, idx: number) => (
                  <TableRow
                    key={val?.id}
                    sx={{
                      cursor: "pointer",
                      marginTop: "10px",
                      padding: "4px !important",
                      borderRadius: "20px !important",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                        outline: "2px solid #f0f0f0",
                        borderRadius: "0px !important",
                        outlineOffset: "-2px !important",
                      },
                    }}
                  >
                    <TableCell>{val?.name}</TableCell>
                    <TableCell>{val?.description}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>
                    <Box
                      sx={{
                        height: "10vh",
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          fontSize: "1rem",
                          color: "#4A4A4A",
                          top: "10px",
                        }}
                      >
                        {"No Data Found."}
                      </span>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableDesign>
          </Grid>
        </>
      </Grid>
    </>
  );
};
export default SalesList;
